<header
  [ngClass]="headerClasses"
  [class.nav-closed]="config.withMenu && !isMenuOpened"
  [class.no-menu]="config.withMenu && !menu"
  data-tfa="pegase-header" role="banner">
  <mat-toolbar>
    <div class="logo-head" [class.no-menu]="config.withMenu && !menu">
      @if (showLogo) {
        <a [href]="linkToAge()"
           [ngClass]="config.logoClass"
           [attr.aria-label]="config.logoLabel"
           data-tfa="pegase-header-link_to_age">
          @if (!config.logoClass) {
            <div class="logo"></div>
          }
        </a>
      }
    </div>

    <div class="module-label">
      @if (config.withModuleIcon) {
        <mat-icon [style.color]="'var(--pcscol-h1, #007894)'" data-tfa="icon-style">{{ icon }}</mat-icon>
      }
      <span class="module-name">{{ title }}</span>
    </div>

    <div class="extra-header-element_container">
      <ng-content select="#header-extra-element"></ng-content>
      @if (isValidEnv()) {
        <span class="env-label">Env.&nbsp;</span>
        <lib-pegase-chip-environement></lib-pegase-chip-environement>
      }
    </div>

    <div class="profile" data-tfa="pegase-header_nav">
      <div>
        <ng-content select="lib-authentication-form"></ng-content>
      </div>
    </div>
  </mat-toolbar>
</header>